import { useMyTenants } from '../tenant/useMyTenants';

/**
 * Platform-admin status for the Tenants surface (fail-closed, WorkLogix
 * PlatformGate pattern). Tenancy v1: derived from `GET /me/tenants`
 * (`isPlatformAdmin`), which the shell already loads once per sign-in — no
 * second probe. `/platform/access` still exists and is still enforced
 * server-side; `usePlatformApi().getPlatformAccess` remains for callers that
 * want the explicit probe.
 *
 * - `loading` — list in flight; the Tenants surface stays hidden.
 * - `granted` — the API says platform admin.
 * - `denied`  — anything else (not admin / error / 401). A non-answer can
 *   only ever mean "no platform access", so denying is the safe default.
 */
export type PlatformAccessStatus = 'loading' | 'granted' | 'denied';

/** The Tenants nav item / screen render only on an explicit grant. */
export function isTenantsVisible(status: PlatformAccessStatus): boolean {
  return status === 'granted';
}

export function usePlatformAccess(): PlatformAccessStatus {
  const my = useMyTenants();
  if (my.data !== null) {
    return my.data.isPlatformAdmin ? 'granted' : 'denied';
  }
  return my.loading ? 'loading' : 'denied';
}
